import { fetchApi } from '../../../lib/fetchApi';
import { KeyValuePair } from '../../../types/KeyValuePair';
import { ClaimFileDownloadDto, ClaimFollowUpRequestDto, ClaimFollowUpResponseDto } from '../types';

const BASE_URL = "/claimFollowUps"

export const getClaimFollowUpRequest = async (claimFollowUpId: string): Promise<ClaimFollowUpRequestDto> => {
    const response = await fetchApi.get(`${BASE_URL}/${claimFollowUpId}/request`) as ClaimFollowUpRequestDto;
    return response;
}

export const sendClaimFollowUpResponse = async (claimFollowUpId: string, body: ClaimFollowUpResponseDto): Promise<void> => {
    const formData = new FormData();

    body.claimFiles?.forEach((cf) => {
        formData.append('claimFiles', cf.id!.toString());
    });

    body.files?.forEach((file) => {
        formData.append('files', file);
    });
    
    formData.append('Response', body.response);

    try {
        await fetchApi.put(`${BASE_URL}/${claimFollowUpId}/response`, formData);        
    } catch (error: any) {
        throw error.response?.data ?? error;
    }
}

export const validateIfFilesAlreadyExistInClaim = async (claimId: number, files: File[]): Promise<KeyValuePair[]> => {
    const formData = new FormData();    
    files.forEach(file => formData.append('files', file));

    const response = await fetchApi.post<KeyValuePair[]>(`${BASE_URL}/validate-files/${claimId}`, formData);
    return response;
}

export const getDownloadFile = async (publicId: string): Promise<ClaimFileDownloadDto> => {
    const response = await fetchApi.get(`${BASE_URL}/download/${publicId}`) as ClaimFileDownloadDto;
    return response;
}